import OrderAcknowledgement from "@iewccouk/Components/OrderAcknowledgement";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import React, { useContext } from "react";
import { connect } from "react-redux";

const OrderDetailssOrderAcknowledgement = () => {
  const order = useContext(OrderStateContext)?.value as any;

    return order ? (
      <OrderAcknowledgement {...order} />
    ) : null;
};

const widgetModule: WidgetModule = {
    component: connect(null)(OrderDetailssOrderAcknowledgement),
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        displayName: "Order Acknowledgement",
        group: "Order Details",
    },
};

export default widgetModule;
